<script setup lang="ts">
import { CustomMarker } from 'vue3-google-map'

import type { DeliveryDataAddress } from '@/store/delivery/delivery.types'

import type { IGoogleCoords } from '@/types/mapServices'

import BalloonMarker from '@/components/Services/Balloons/BalloonMarker.vue'

import type { PolygonProperties } from '@/api/modules/delivery/types'

type Props = {
  clickedMarkerCoordinates: IGoogleCoords
  deliveryAddressDetails: PolygonProperties | null
  selectedAddress: DeliveryDataAddress | null
}

const props = defineProps<Props>()

const optionsMarker = computed((): google.maps.CustomMarkerOptions => {
  return {
    position: props.clickedMarkerCoordinates,
    anchorPoint: 'BOTTOM_CENTER',
  }
})
</script>

<template>
  <custom-marker :options="optionsMarker">
    <balloon-marker
      :details="deliveryAddressDetails"
      :selected-address="selectedAddress"
    />
  </custom-marker>
</template>
